import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PROMOTIONBLOCK_LEGACY_FIELD_ORDER = [
  "title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  promotionBlockDescriptor: _generatedPromotionBlockDescriptor,
  promotionBlockBlocDefinition,
  promotionBlockDashboardLayout,
  promotionBlockConfig,
  promotionBlockResolveConfig,
  promotionBlockProperties,
} = doodBlockConfig(
  {
    name: "Nos Promos",
    componentType: 'PromotionBlockComponent',
    category: 'catalog',
    description: "Nos Promos.",
    keywords: [],
    allowedIn: [
      { bloc: 'ShopPageComponent', slot: '*' },
      { bloc: 'GenericPageComponent', slot: '*' },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'translation',
      value: '',
      options: {
        label: "pages.blocks.promotion.title.label",
        placeholder: "pages.blocks.promotion.title.placeholder",
        help: "pages.blocks.promotion.title.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.promotion.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.promotion.fieldset.title.label",
            fields: ["title"],
          },
        ],
      },
    ],
  })
);

export function promotionBlockDescriptor(): IBlockDescriptor;
export function promotionBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function promotionBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPromotionBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPromotionBlockDescriptor, promotionBlockProperties, fieldOrder);
}

export {
  promotionBlockBlocDefinition,
  promotionBlockDashboardLayout,
  promotionBlockProperties,
  promotionBlockConfig,
  promotionBlockResolveConfig,
};

export type PromotionBlockConfig = typeof promotionBlockConfig;
